import BillsComponent from './Bills/BillsComponent';
import ReplacementComponent from './Replacements/ReplacementComponent';
import UserDataComponent from './UserData/UserDataComponent';

export const AssetsTabs = [
  {
    title: 'User Data',
    index: 0,
    component: <UserDataComponent />,
  },
  {
    title: 'Replacements',
    index: 1,
    component: <ReplacementComponent />,
  },
  {
    title: 'Bills',
    index: 1,
    component: <BillsComponent />,
  },
];
